export { default as Bold } from './Bold'
export { default as Medium } from './Medium'
export { default as MediumIt } from './MediumIt'
export { default as Regular } from './Regular'
export { default as SemiBoldIt } from './SemiBoldIt'



// WEBPACK FOOTER //
// ./src/styles/fonts/RawsonPro/index.js